
<div>
    <div style="position: relative">
        <img
            v-if="image"
            :src="image"
            class="image"
        />
    </div>
</div>
